function Footer(props){
    return(
        <footer className="footer text-center">
            Tous droits réservés par Admin. Conçu et développé par 
            <a href="#!"> DJOBO NDRI FRANCOIS CAREM</a>.
        </footer>
    )
}

export default Footer;